module.exports = __webpack_public_path__ + "images/file_icons_v2/sdf-5ee045f44841d165246eb40e35854afe.svg";